'use es6';

import { makeAsyncComponent, makeAsyncComponentWithOverlay, makeAsyncModuleEditFormComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import makeAsyncEmojiPickerContent from 'ui-addon-emoji-picker/picker/makeAsyncEmojiPickerContent';
import AsyncMofoFields from 'ContentEditorUI/components/AsyncMofoFields';
import { getThemeSettingsFields } from 'ContentEditorUI/components/AsyncThemeSettingsFields';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncSmartRulesSelectWithManageOptions = makeAsyncComponent(() => import( /* webpackChunkName: 'SmartRulesSelectWithManageOptions' */'smart-content-lib/components/input/SmartRulesSelectWithManageOptions'));
const AsyncMakeSmartButton = makeAsyncComponent(() => import( /* webpackChunkName: 'MakeSmartButton' */'smart-content-lib/components/button/MakeSmartButton'));
export const AsyncGroupedModuleStylesEditorContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'ModuleGroupedStylesEditor' */'ContentEditorUI/components/sidebar/styles/GroupedModuleStylesEditorContainer'));
const AsyncEmbedModalContainer = makeAsyncComponentWithOverlay(() => {
  return import( /* webpackChunkName: 'EmbedModalContainer' */'tinymce-plugins/components/EmbedModalContainer');
});
const AsyncFileManagerModalContainer = makeAsyncComponentWithOverlay(() => {
  return import( /* webpackChunkName: 'FileManagerModalContainer' */'tinymce-plugins/components/FileManagerModalContainer');
});
const AsyncEditVideoModalContainer = makeAsyncComponentWithOverlay(() => {
  return import( /* webpackChunkName: 'EditVideoModalContainer' */'ContentEditorUI/components/modals/EditVideoModalContainer');
});
const AsyncVideoPickerContainer = makeAsyncComponentWithOverlay(() => {
  return import( /* webpackChunkName: 'VideoPickerContainer' */'tinymce-plugins/components/VideoPickerContainer');
});
const AsyncFormPickerContainer = makeAsyncComponentWithOverlay(() => {
  return import( /* webpackChunkName: 'FormPickerContainer' */'tinymce-plugins/components/FormPickerContainer');
});
const AsyncCtaPickerContainer = makeAsyncComponentWithOverlay(() => {
  return import( /* webpackChunkName: 'CtaPickerContainer' */'tinymce-plugins/components/CtaPickerContainer');
});
const AsyncContentAssistanceToolbar = makeAsyncComponent(() => {
  import( /* webpackChunkName: "ContentAssistanceToolbar" */'ContentEditorUI/containers/ContentAssistanceToolbarContainer');
});
const AsyncContentAssistanceAutocompleteMenu = makeAsyncComponent(() => import( /* webpackChunkName: "ContentAssistanceAutocompleteMenu" */'ContentEditorUI/containers/ContentAssistanceAutocompleteContainer'));
const AsyncFormPicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: 'form-picker' */'form-picker/components/FormPicker'));
const AsyncCtaPicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: 'cta-picker' */'cta-picker/components/CTAPicker'));
export const AsyncEmojiPicker = makeAsyncEmojiPickerContent(() => import( /* webpackChunkName: "emoji-picker" */'ui-addon-emoji-picker/picker/EmojiPickerContent'));
const AsyncFilePicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "file-picker" */'ContentEditorUI/components/shared/FilePicker'));
const AsyncBaymaxRevisionsModal = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: 'baymax-revisions-modal' */'editor-components/modals/EPRevisionsModal'));
const AsyncStaticModulesInNonDefaultBreakpointStylesEditor = makeAsyncComponent(() => import( /* webpackChunkName: 'StaticModulesInNonDefaultBreakpointStylesEditor' */'ContentEditorUI/js/components/sidebar/styles/StaticModulesInNonDefaultBreakpointStylesEditor'));
const AsyncLayoutStylesSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'LayoutStylesSidebarContainer' */'ContentEditorUI/containers/layoutStyles/LayoutStylesSidebarContainer'));
const AsyncEditTemplateModal = makeAsyncComponent(() => import( /* webpackChunkName: 'EditTemplateModal' */'ContentEditorUI/components/settings/EditTemplateModal'));
const AsyncModuleEditSmartFields = makeAsyncComponent(() => import( /* webpackChunkName: 'ModuleEditSmartFields' */'ContentEditorUI/components/sidebar/edit/ModuleEditSmartFields'));
const AsyncMediaBridgePicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "media-bridge-picker" */'media-bridge-lib/components/media-picker/MediaPicker'));
const AsyncHubSpotVideoPicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "hubspot-video-picker" */'media-bridge-lib/components/media-picker/HubSpotVideoPicker'));
const AsyncAddSectionContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'AddSectionContainer' */'ContentEditorUI/containers/sections/AddSectionContainer'));
const AsyncCreateNewSectionPanel = makeAsyncComponent(() => import( /* webpackChunkName: 'CreateNewSectionPanel' */'ContentEditorUI/containers/sections/CreateNewSectionPanel'));
const AsyncDeleteSavedSectionModal = makeAsyncComponent(() => import( /* webpackChunkName: 'DeleteSavedSectionModal' */'ContentEditorUI/components/sections/DeleteSavedSectionModal'));
const AsyncSectionsInstructionModal = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "sections-announcement-modal" */'ContentEditorUI/components/sections/SectionsInstructionModal'));
const AsyncCopyAsHublContainer = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "CopyAsHublContainer" */'ContentEditorUI/components/CopyAsHubLContainer'));
const AsyncSmartRulePreviewToolbar = makeAsyncComponent(() => import( /* webpackChunkName: 'SmartRulePreviewToolbar' */'ContentEditorUI/components/shared/SmartRulePreviewToolbar'), {
  // Overriding the default LoadingComponent here to ensure that the component that's rendered while
  // the chunk is loading has a height of 25px (the height of the SmartRulePreviewToolbar).
  // That way, the iframe is resized, ensuring that the toolbar is visible once the chunk is available.
  LoadingComponent: () => /*#__PURE__*/_jsx("div", {
    style: {
      height: 25
    },
    children: /*#__PURE__*/_jsx(UILoadingOverlay, {
      use: "dots",
      contextual: true
    })
  })
});
const AsyncSocialComposerPanel = makeAsyncComponent(() => import( /* webpackChunkName: 'SocialComposerPanel' */'social-composer-lib/components/SocialComposerPanel'));
const AsyncActiveThemeCreatePageModal = makeAsyncComponent(() => import( /* webpackChunkName: 'ActiveThemeCreatePageModal' */'ui-active-theme-content-creator-lib/components/CreatePageModal'));
export const getAsyncComponents = ({
  extraComponents = {},
  extraMofoFields = {},
  extraTinyMceModals = {}
} = {}) => {
  const mofoFields = Object.assign({}, AsyncMofoFields, extraMofoFields);
  const AsyncModuleEditForm = makeAsyncModuleEditFormComponent(mofoFields, () => import( /* webpackPrefetch: true, webpackChunkName: 'module-edit-form' */'ContentComponents/cmv2/EditForm'));
  const themeSettingsFields = getThemeSettingsFields(mofoFields);
  const AsyncThemeEditForm = makeAsyncModuleEditFormComponent(themeSettingsFields, () => import( /* webpackChunkName: 'module-edit-form' */'ContentComponents/cmv2/EditForm'));
  return Object.assign({
    ModuleEditForm: AsyncModuleEditForm,
    GroupedModuleStylesEditorContainer: AsyncGroupedModuleStylesEditorContainer,
    smartContentComponents: {
      SmartRulesSelectWithManageOptions: AsyncSmartRulesSelectWithManageOptions,
      // I don't think we actually use this anymore? Can't find a ref to it
      MakeSmartButton: AsyncMakeSmartButton
    },
    BaymaxRevisionsModal: AsyncBaymaxRevisionsModal,
    tinyMceModals: Object.assign({
      EmbedModalContainer: AsyncEmbedModalContainer,
      FileManagerModalContainer: AsyncFileManagerModalContainer,
      EditVideoModalContainer: AsyncEditVideoModalContainer,
      VideoPickerContainer: AsyncVideoPickerContainer,
      FormPickerContainer: AsyncFormPickerContainer,
      CtaPickerContainer: AsyncCtaPickerContainer
    }, extraTinyMceModals),
    pickerComponents: {
      AsyncFormPicker,
      AsyncCtaPicker,
      AsyncEmojiPicker,
      AsyncFilePicker,
      AsyncMediaBridgePicker,
      AsyncHubSpotVideoPicker,
      ContentAssistanceToolbar: AsyncContentAssistanceToolbar,
      ContentAssistantAutocompleteMenu: AsyncContentAssistanceAutocompleteMenu
    },
    ThemeEditForm: AsyncThemeEditForm,
    StaticModulesInNonDefaultBreakpointStylesEditor: AsyncStaticModulesInNonDefaultBreakpointStylesEditor,
    LayoutStylesSidebarContainer: AsyncLayoutStylesSidebarContainer,
    EditTemplateModal: AsyncEditTemplateModal,
    ModuleEditSmartFields: AsyncModuleEditSmartFields,
    AddSectionContainer: AsyncAddSectionContainer,
    CreateNewSectionPanel: AsyncCreateNewSectionPanel,
    DeleteSavedSectionModal: AsyncDeleteSavedSectionModal,
    SectionsInstructionModal: AsyncSectionsInstructionModal,
    SmartRulePreviewToolbar: AsyncSmartRulePreviewToolbar,
    CopyAsHublContainer: AsyncCopyAsHublContainer,
    SocialComposerPanel: AsyncSocialComposerPanel,
    ActiveThemeCreatePageModal: AsyncActiveThemeCreatePageModal,
    mofoFields
  }, extraComponents);
};